<template>
    <div class="form-control-counter" :class="{ 'form-counter-overlay': overlay >= 0 }">
        <input type="number" v-model="content" :class="classes" :name="name" :min="min" :max="max" :step="step" :disabled="disabled" @focus="$event.target.select()" />
        <span v-if="overlay !== null" class="counter-overlay">{{ overlay }}</span>
        <label >{{label}}</label>
        <i class="fas fa-plus form-control-counter-toggle" data-type="plus" @click="maybe(1)"></i>
        <i class="fas fa-minus form-control-counter-toggle" data-type="minus" @click="maybe(0)"></i>
    </div>
</template>

<script>
import objectPath from 'object-path';

export default {
    props: [
        'label', 'value', 'classes', 'min', 'max', 'step', 'name',
        'clone', 'arr', 'overlay'
    ],
    data () {
        return {
            content: parseInt(this.value) || 0,
            skip: false,
            disabled: false,
            oldVal: false,
            difference: 0,
            counting: false,
        };
    },
    methods: {
        is_counting () {
            let vm = this;

            if (this.counting) return true;

            this.counting = true;

            setTimeout(() => {
                vm.counting = false;
            }, 250);
        },
        maybe (plus) {
            if (this.is_counting() || this.disabled) return;

            if (plus) {
                if (this.max && (this.content + 1) > +this.max) return;

                this.content++;
            } else {
                if (this.min && (this.content - 1) < +this.min) return;

                this.content--;
            }
        },
        plus () {
            let $this = this;

            if (typeof this.clone !== 'undefined') {
                let clone = objectPath.get(app, this.clone);
                let arr = typeof this.arr != 'undefined'
                    ? this.arr
                    : Object.byString(app, clone.arr);

                app.clone_create(
                    clone.create_url,
                    clone.create_data,
                    arr,
                    clone.model,
                    () => { $this.difference--; },
                    () => {
                        $this.skip = true;
                        $this.content--;
                        $this.difference--;
                    }
                );
            }
        },
        minus () {
            let $this = this;

            if ($this.content < 0) return;

            if (typeof this.clone !== 'undefined') {
                let clone = objectPath.get(app, this.clone);
                let arr = typeof this.arr != 'undefined'
                    ? this.arr
                    : Object.byString(app, clone.arr);

                let delete_item = arr[arr.length - 1];

                app.clone_remove(
                    clone.delete_url,
                    delete_item,
                    arr,
                    arr.findIndex((ele) => { return delete_item.id == ele.id; }),
                    () => { $this.difference--; },
                    () => {
                        $this.skip = true;
                        $this.content++;
                        $this.difference--;
                    }
                );
            }
        }
    },
    mounted () {
        let id = uniqid();
        let parent = $(this.$el);
        parent.find("input").attr("id", id);
        parent.prev().attr("for", id);
        parent.next().attr("id", id+"-message");
    },
    watch: {
        content (newVal, oldVal) {
            let vm = this;
            let nVal = parseInt(newVal);

            if (isNaN(nVal)) return;

            if (!isNaN(parseInt(this.min))) {
                if (nVal < this.min) {
                    this.content = this.min;
                    return;
                }
            }

            if (!isNaN(parseInt(this.max))) {
                if (nVal > this.max) {
                    this.content = this.max;
                    return;
                }
            }

            if (this.skip) {
                this.skip = false;
                return;
            }

            if (this.disabled) return;

            if (this.oldVal === false) this.oldVal = oldVal;

            if (newVal == this.oldVal) return;

            if (typeof this.clone !== 'undefined') {
                this.disabled = true;

                let allow = setInterval(() => {
                    if (!vm.difference) {
                        clearInterval(allow);
                        vm.disabled = false;
                    }
                }, 100);
            }

            if (nVal > this.oldVal) {
                this.difference = nVal - this.oldVal;

                for (let i = 0, len = this.difference; i < len; i++) {
                    this.plus();
                }
            } else {
                this.difference = this.oldVal - nVal;

                for (let i = 0, len = this.difference; i < len; i++) {
                    this.minus();
                }
            }

            this.$emit('input', nVal);
            $(this.$el).find('input').val(nVal);
            $(this.$el).find('input').trigger('change');
            this.oldVal = nVal;
        },
        value (newVal, oldVal) {
            this.content = newVal;
        },
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/counter.vue